<script>
import store from '../store/';
var discourse_sso = require('../services/DiscourseSso');


export default {
    data: () => ({
       
    }),
    components: {
    },
    mounted() {
        const self = this;
        
    },
    created() {
        const self = this;
        var payload = self.$route.query.sso; // fetch from incoming request
		var sig = self.$route.query.sig; // fetch from incoming request
		var sso = new discourse_sso("loadmax_forum_secret");

		if(!sso.validate(payload, sig)) {
			header("HTTP/1.1 403 Forbidden");
		    echo("Bad SSO request");
		    die();
		}

		var nonce = sso.getNonce(payload);



		const isLoggedIn = store.state.user;

		var userparams = {
		    "nonce": nonce,
		    "external_id": isLoggedIn.uuid,
		    "email": isLoggedIn.email,
		    "name": isLoggedIn.name,
			
		};
		var q = sso.buildLoginString(userparams);

		window.location = 'https://forum.loadmax.com/session/sso_login?' + q;

    },
    methods: {
      
    }
};

</script>
<template>
<div style="text-align:center;">
	<h1>
		Processing ...
	</h1>
	</div>
</template>


// WEBPACK FOOTER //
// src/pages/sso.vue